export default __webpack_public_path__ + "static/media/label_detect.42aef2b1.png";